// extracted by mini-css-extract-plugin
export default {"overlay":"aB-z","bodyOpen":"bB-z","content":"cB-z","header":"dB-z","close":"eB-z","closeNoHeading":"fB-z"};